/*eslint-disable */
let LBILBaseURL = process.env.VUE_APP_LBIL_API_BASE_URL;
let lbilRoots = {
lbilAdminLoginApiUrl: {
    "link": LBILBaseURL + "api/account/superuser/login/"
},
lbilAdminLoginVerfiyApiUrl: {
    "link": LBILBaseURL + "api/account/superuser/login-verify/"
},
lbilAdminLogoutApiUrl: {
    "link": LBILBaseURL + "api/account/superuser/logout/"
},
lbilSUserInfoApiUrl: {
  "link": LBILBaseURL + "api/account/user/user-detail/"
},
doctorConsultReqApiUrl: {
  "link": LBILBaseURL + "api/account/superuser/approval/"
},
doctorConsultApiUrl: {
  "link": LBILBaseURL + "api/account/consult/doctors/"
},
doctorConsultReqLisApiUrl: {
  "link": LBILBaseURL + "api/account/superuser/doctor/approval/"
},
lbilAllUsersListApiUrl:{
  "link": LBILBaseURL + "api/account/superuser/users/"
}
}
export default lbilRoots;